module.exports = __webpack_public_path__ + "img/gbsinbo_02.d37fc4c7.png";